import React, { Component } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  Grid,
  Paper,
  TextField,
  InputAdornment,
  Chip,
  Avatar,
  Card,
  CardContent,
  CardActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress
} from '@mui/material';
import { AuthContext } from '../../context/AuthContext';

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import GridViewIcon from '@mui/icons-material/GridView';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';

class Delivery extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      tipoFiltro: 'todos',
      searchQuery: '',
      pedidos: [],

      // Estados de controle dos Dialogs
      dialogProduzirOpen: false,
      dialogCancelarOpen: false,
      pedidoSelecionado: null,
      motivoCancelamento: '',
      dialogPronto: {},
      dialogDespachar: {},
      dialogEntregue: {},
      loadingAction: false
    };

    // Guarda o ID do último pedido carregado para evitar loop infinito
    this.lastProcessedOrderId = null;
  }


  componentDidMount() {
    this.carregarPedidos();
  }

  // Função auxiliar para formatar cada pedido vindo da API
  formatarPedido = (p) => {
    const itens = (p.itens || []).map(item => ({
      ...item,
      opcoes: item.opcoes || []
    }));

    // Se o total geral vier 0 ou indefinido, calcula a soma dos itens
    let valorTotalNum = Number(p.total) || 0;
    if (valorTotalNum === 0 && itens.length > 0) {
      valorTotalNum = itens.reduce((acc, item) => acc + (Number(item.valor_total) || 0), 0);
    }

    // Monta a string do endereço caso os campos venham separados
    let enderecoTexto = 'Endereço não informado';
    if (p.rua) {
      const num = p.numero ? `, ${p.numero}` : '';
      const bairro = p.bairro ? ` - ${p.bairro}` : '';
      const cidade = p.cidade ? ` - ${p.cidade}` : '';
      const uf = p.estado ? `/${p.estado}` : '';
      enderecoTexto = `${p.rua}${num}${bairro}${cidade}${uf}`;
    } else if (p.endereco) {
      enderecoTexto = p.endereco;
    }

    return {
      id: p.id,
      codigo: p.codigo || `#${p.id}`,
      cliente: p.cliente || 'Cliente não identificado',
      tipo: p.tipo || 'delivery',
      status: p.status,
      itens: itens,
      total: valorTotalNum, // Valor numérico para cálculos e impressora
      totalFormatado: valorTotalNum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      endereco: enderecoTexto,
      // Mapeamento dos campos individuais para o cupom de entrega
      rua: p.rua || '',
      numero: p.numero || '',
      bairro: p.bairro || '',
      cidade: p.cidade || '',
      estado: p.estado || '',
      complemento: p.complemento || '',
      referencia: p.referencia || ''
    };
  };

  LoadOrder = async (id) => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
      const response = await fetch(`${baseUrl}/delivery/order/${id}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const novoPedidoData = await response.json();
        const rawPedido = Array.isArray(novoPedidoData) ? novoPedidoData[0] : novoPedidoData;

        if (rawPedido) {
          const novoPedido = this.formatarPedido(rawPedido);

          this.setState((prevState) => ({
            // Remove duplicações caso o pedido já exista no estado antes de adicionar
            pedidos: [novoPedido, ...prevState.pedidos.filter(p => p.id !== novoPedido.id)],
          }));

          toast.success(`📦 Novo pedido ${novoPedido.codigo} recebido!`);
        }
      }
    } catch (error) {
      console.error(`Erro ao carregar o pedido #${id}:`, error);
    }
  };

  carregarPedidos = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        const pedidosFormatados = (Array.isArray(data) ? data : []).map(this.formatarPedido);

        this.setState({ pedidos: pedidosFormatados });
      }
    } catch (error) {
      console.error("Erro ao carregar pedidos do delivery:", error);
    }
  };

  componentDidUpdate() {
    const currentLastOrder = this.context?.lastOrder;

    // SÓ EXECUTA SE:
    // 1. Houver um lastOrder no contexto
    // 2. O ID desse pedido for DIFERENTE do último que já processamos
    if (currentLastOrder?.id && currentLastOrder.id !== this.lastProcessedOrderId) {
      // Atualiza a referência IMEDIATAMENTE para travar novas chamadas
      this.lastProcessedOrderId = currentLastOrder.id;

      // Carrega o pedido
      this.LoadOrder(currentLastOrder.id);
    }
  }



  handleFiltroChange = (novoFiltro) => {
    this.setState({ tipoFiltro: novoFiltro });
  };

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  // Abrir Modal Produzir
  handleOpenProduzir = (pedido) => {
    this.setState({
      pedidoSelecionado: pedido,
      dialogProduzirOpen: true
    });
  };

  // Abrir Modal Cancelar
  handleOpenCancelar = (pedido) => {
    this.setState({
      pedidoSelecionado: pedido,
      motivoCancelamento: '',
      dialogCancelarOpen: true
    });
  };

  // Fechar qualquer Dialog
  handleCloseDialogs = () => {
    if (this.state.loadingAction) return;
    this.setState({
      dialogProduzirOpen: false,
      dialogCancelarOpen: false,
      dialogPronto: {},
      dialogDespachar: {},
      dialogEntregue: {},
      pedidoSelecionado: null,
      motivoCancelamento: ''
    });
  };

  // Confirmar início de produção com Impressão Térmica Automática no Success da API
  handleConfirmarProduzir = async () => {
    const { pedidoSelecionado } = this.state;
    if (!pedidoSelecionado) return;

    this.setState({ loadingAction: true });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery/status`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          pedido_id: pedidoSelecionado.id,
          status: 'em_producao'
        })
      });

      if (response.ok) {
        this.handleMudarStatusLocal(pedidoSelecionado.id, 'em_producao');

        // Impressão da via da Cozinha dispara aqui na confirmação da API
        this.handleImprimirCozinha(pedidoSelecionado);

        this.setState({ dialogProduzirOpen: false });
        toast.success('Pedido enviado para produção e impresso!');
      } else {
        toast.error('Erro ao atualizar status do pedido para produção.');
      }
    } catch (error) {
      console.error('Erro ao enviar requisição de produção:', error);
      toast.error('Falha na comunicação com o servidor.');
    } finally {
      this.setState({ loadingAction: false });
    }
  };

  // Confirmar cancelamento
  handleConfirmarCancelar = async () => {
    const { pedidoSelecionado, motivoCancelamento } = this.state;
    if (!pedidoSelecionado) return;

    this.setState({ loadingAction: true });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery/cancel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          pedido_id: pedidoSelecionado.id,
          motivo: motivoCancelamento
        })
      });

      if (response.ok) {
        this.handleMudarStatusLocal(pedidoSelecionado.id, 'cancelados');
        this.setState({ dialogCancelarOpen: false });
        toast.success('Pedido cancelado com sucesso.');
      } else {
        toast.error('Erro ao cancelar o pedido.');
      }
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error);
      toast.error('Falha na comunicação com o servidor.');
    } finally {
      this.setState({ loadingAction: false });
    }
  };

  // Atualização no estado local
  handleMudarStatusLocal = (idPedido, proximoStatus) => {
    this.setState(prevState => ({
      pedidos: prevState.pedidos.map(p => {
        if (p.id === idPedido) {
          return { ...p, status: proximoStatus };
        }
        return p;
      })
    }));
  };

  // Impressão Térmica com Suporte a Opções/Adicionais

  handleImprimirCozinha = (pedido) => {
    // 1. Extração do objeto correto do pedido
    const dadosPedido = pedido.id ? pedido : Object.values(pedido)[0];
    if (!dadosPedido) return;

    const horaAtual = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    const itens = dadosPedido.itens || [];
    const tipoPedido = (dadosPedido.tipo || 'DELIVERY').toUpperCase();
    const codigoPedido = dadosPedido.codigo || '#' + dadosPedido.id;

    // ==========================================
    // SEÇÃO 1: VIA DA COZINHA (MONTAGEM EM TEXTO)
    // ==========================================
    let itensCozinha = '';
    itens.forEach(item => {
      const nomeProduto = (item.produto_nome || item.nome || '').toUpperCase();

      // Quantidade + Nome do Produto
      itensCozinha += `\\x1b\\x45\\x01\\x1b\\x21\\x30${item.quantidade}x ${nomeProduto}\n\\x1b\\x21\\x00`;

      // Opções e Variações
      if (item.opcoes && item.opcoes.length > 0) {
        item.opcoes.forEach(op => {
          const grupoStr = op.grupo ? `${op.grupo.toUpperCase()}: ` : '';
          const nomeOp = (op.nome || '').toUpperCase();
          itensCozinha += `\\x1b\\x45\\x01   * ${grupoStr}${nomeOp}\n\\x1b\\x45\\x00`;
        });
      }

      // Observação do Item
      if (item.obs && item.obs.trim() !== '') {
        itensCozinha += `\\x1b\\x45\\x01   * OBS: ${item.obs.trim().toUpperCase()}\n\\x1b\\x45\\x00`;
      }

      itensCozinha += '--------------------------------\n';
    });

    // MONTAGEM DO CORPO DA COZINHA
    let payloadData =
      "\\x1b\\x42\\x03\\x02\\x1b\\x61\\x01--------------------------------\n" +
      `\\x1b\\x45\\x01\\x1b\\x21\\x30[ ${tipoPedido} ]\nPEDIDO ${codigoPedido}\n\\x1b\\x21\\x00` +
      "--------------------------------\n" +
      `\\x1b\\x61\\x00HORA: ${horaAtual}\n` +
      "================================\n" +
      itensCozinha +
      "================================\n" +
      "\\x1b\\x61\\x01\\x1b\\x45\\x01=== VIA DA COZINHA ===\\x1b\\x45\\x00\n\n\n\n";

    // ==========================================
    // SEÇÃO 2: VIA DO ENTREGADOR / EXPEDIÇÃO
    // ==========================================
    if (tipoPedido === 'DELIVERY') {
      const cliente = (dadosPedido.cliente || 'NAO INFORMADO').toUpperCase();

      let enderecoFormatado = '';
      if (dadosPedido.rua) {
        const rua = dadosPedido.rua.toUpperCase();
        const num = dadosPedido.numero ? `, ${dadosPedido.numero}` : '';
        const bairro = dadosPedido.bairro ? ` - ${dadosPedido.bairro.toUpperCase()}` : '';
        const cidade = dadosPedido.cidade ? ` - ${dadosPedido.cidade.toUpperCase()}` : '';
        const uf = dadosPedido.estado ? `/${dadosPedido.estado.toUpperCase()}` : '';
        enderecoFormatado = `${rua}${num}${bairro}${cidade}${uf}`;
      } else {
        enderecoFormatado = (dadosPedido.endereco || 'RETIRADA / SEM ENDERECO').toUpperCase();
      }

      const complementoStr = dadosPedido.complemento ? `\n\\x1b\\x45\\x01COMP: ${dadosPedido.complemento.toUpperCase()}\\x1b\\x45\\x00` : '';
      const referenciaStr = dadosPedido.referencia ? `\n\\x1b\\x45\\x01REF: ${dadosPedido.referencia.toUpperCase()}\\x1b\\x45\\x00` : '';
      const totalFormatado = Number(dadosPedido.total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

      payloadData +=
        "\\x1b\\x61\\x01--------------------------------\n" +
        `\\x1b\\x45\\x01\\x1b\\x21\\x30ENTREGA ${codigoPedido}\n\\x1b\\x21\\x00` +
        "--------------------------------\n" +
        `\\x1b\\x61\\x00CLIENTE: ${cliente}\n` +
        `ENDERECO: ${enderecoFormatado}${complementoStr}${referenciaStr}\n` +
        "--------------------------------\n" +
        `\\x1b\\x45\\x01\\x1b\\x21\\x20TOTAL: ${totalFormatado}\\x1b\\x21\\x00\\x1b\\x45\\x00\n` +
        "================================\n" +
        "\\x1b\\x61\\x01\\x1b\\x45\\x01=== VIA DO ENTREGADOR ===\\x1b\\x45\\x00\n\n\n\n";
    }

    // ==========================================
    // ENVIO VIA WEBSOCKET CONFORME O MODELO QUE FUNCIONA
    // ==========================================
    const print = localStorage.getItem("print");

    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(
        JSON.stringify({
          type: 'print',
          printer: print || null,
          data: payloadData
        })
      );
    } else if (this.context && typeof this.context.printData === 'function') {
      // Fallback usando o método do contexto se o WebSocket direto não estiver exposto
      this.context.printData(payloadData, print);
    }
  };

  handleImprimirEntrega = (pedido) => {
    const { printData } = this.context;
    if (!printData) return;

    const itensFormatados = (pedido.itens || []).map(item => {
      let textoItem = `- ${item.quantidade}x ${item.produto_nome}\n`;
      if (item.opcoes && item.opcoes.length > 0) {
        item.opcoes.forEach(op => {
          textoItem += `   * ${op.grupo || 'Opção'}: ${op.nome}\n`;
        });
      }
      return textoItem;
    }).join('');

    const impressaoPayload =
      '\x1B@' +
      '\x1Ba\x01' +
      '*** ETIQUETA DE ENTREGA ***\n' +
      '--------------------------------\n' +
      `PEDIDO: ${pedido.codigo}\n` +
      `CLIENTE: ${pedido.cliente}\n` +
      `TIPO: ${pedido.tipo ? pedido.tipo.toUpperCase() : 'DELIVERY'}\n` +
      '--------------------------------\n' +
      '\x1Ba\x00' +
      `ENDERECO:\n${pedido.endereco}\n\n` +
      `ITENS:\n${itensFormatados}` +
      '--------------------------------\n' +
      '\x1Ba\x01' +
      '\x1DV\x00';
    var print = localStorage.getItem("print");
    if (print != null) {
      printData(impressaoPayload, print);
    } else {
      printData(impressaoPayload);
    }
  };

  // Renderização das Opções em cada Cartão
  renderItensPedido = (itens) => {
    if (!itens || itens.length === 0) return null;

    return (
      <Box component="div" sx={{ mb: 1 }}>
        {itens.map((item, idx) => (
          <Box key={idx} sx={{ mb: 1, pb: 0.5, borderBottom: idx < itens.length - 1 ? '1px dashed #eee' : 'none' }}>
            <Typography variant="caption" sx={{ fontWeight: 700, display: 'block', color: '#212121' }}>
              • {item.quantidade}x {item.produto_nome}
            </Typography>

            {/* Renderização limpa das opções */}
            {item.opcoes && item.opcoes.length > 0 && (
              <Box sx={{ pl: 1.5, my: 0.5 }}>
                {item.opcoes.map((op, opIdx) => (
                  <Typography key={opIdx} variant="caption" display="block" sx={{ color: '#1565c0', fontSize: '0.72rem', fontWeight: 500 }}>
                    ↳ <strong>{op.grupo}:</strong> {op.nome}
                    {op.preco_adicional > 0 && ` (+R$ ${Number(op.preco_adicional).toFixed(2).replace('.', ',')})`}
                  </Typography>
                ))}
              </Box>
            )}

            {/* Observações */}
            {item.obs && (
              <Typography variant="caption" color="error" display="block" sx={{ fontStyle: 'italic', pl: 1.5 }}>
                Obs: {item.obs}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    );
  };

  render() {
    const { tipoFiltro, searchQuery, pedidos, dialogProduzirOpen, dialogCancelarOpen, pedidoSelecionado, motivoCancelamento, loadingAction } = this.state;

    const pedidosFiltrados = pedidos.filter(p => {
      const matchTipo = tipoFiltro === 'todos' || p.tipo === tipoFiltro;
      const matchBusca = (p.cliente && p.cliente.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (p.codigo && p.codigo.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchTipo && matchBusca;
    });

    const received = pedidosFiltrados.filter(p => p.status === 'received');
    const emProducao = pedidosFiltrados.filter(p => p.status === 'em_producao');
    const pronto = pedidosFiltrados.filter(p => p.status === 'pronto');
    const emRota = pedidosFiltrados.filter(p => p.status === 'em_rota');
    const entregues = pedidosFiltrados.filter(p => p.status === 'entregues');

    const stats = [
      { id: 'received', label: 'RECEBIDOS', count: received.length, icon: <InboxOutlinedIcon />, color: '#7b1fa2', bgColor: '#f3e5f5' },
      { id: 'em_producao', label: 'EM PRODUÇÃO', count: emProducao.length, icon: <AccessTimeOutlinedIcon />, color: '#ed6c02', bgColor: '#fff8e1' },
      { id: 'pronto', label: 'PRONTO', count: pronto.length, icon: <CheckCircleOutlineOutlinedIcon />, color: '#2e7d32', bgColor: '#e8f5e9' },
      { id: 'em_rota', label: 'EM ROTA', count: emRota.length, icon: <LocalShippingOutlinedIcon />, color: '#0288d1', bgColor: '#e3f2fd' },
      { id: 'entregues', label: 'ENTREGUES', count: entregues.length, icon: <CheckCircleOutlineOutlinedIcon />, color: '#2e7d32', bgColor: '#e8f5e9' },
    ];

    return (
      <Box sx={{ minHeight: '100vh', fontFamily: 'Roboto, sans-serif', p: 0 }}>
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ fontSize: '0.875rem', mb: 1 }}>
              <Link underline="hover" color="inherit" href="#">Início</Link>
              <Typography color="text.primary" fontSize="0.875rem">Pedidos</Typography>
            </Breadcrumbs>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar sx={{ bgcolor: '#f3e5f5', color: '#7b1fa2', width: 36, height: 36 }}>
                <AssignmentOutlinedIcon fontSize="small" />
              </Avatar>
              <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
                Painel de Operações Delivery
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Gerencie fluxo de pedidos, impressões térmicas para cozinha/entrega e Kanban em tempo real.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 1.5, mb: 3, flexWrap: 'wrap' }}>
          <Button
            variant={tipoFiltro === 'todos' ? 'contained' : 'outlined'}
            onClick={() => this.handleFiltroChange('todos')}
            startIcon={<GridViewIcon />}
            endIcon={<Chip label={pedidos.length} size="small" sx={{ height: 20, fontSize: '0.75rem', bgcolor: '#e0e0e0' }} />}
            sx={{ borderRadius: '12px', textTransform: 'none', borderColor: '#e0e0e0', color: tipoFiltro === 'todos' ? '#fff' : '#424242', bgcolor: tipoFiltro === 'todos' ? '#6a1b9a' : '#fff' }}
          >
            Todos
          </Button>
          <Button
            variant={tipoFiltro === 'delivery' ? 'contained' : 'outlined'}
            onClick={() => this.handleFiltroChange('delivery')}
            startIcon={<LocalShippingOutlinedIcon />}
            sx={{ borderRadius: '12px', textTransform: 'none', borderColor: '#e0e0e0', color: tipoFiltro === 'delivery' ? '#fff' : '#424242', bgcolor: tipoFiltro === 'delivery' ? '#6a1b9a' : '#fff' }}
          >
            Delivery
          </Button>
          <Button
            variant={tipoFiltro === 'retirada' ? 'contained' : 'outlined'}
            onClick={() => this.handleFiltroChange('retirada')}
            startIcon={<ShoppingBagOutlinedIcon />}
            sx={{ borderRadius: '12px', textTransform: 'none', borderColor: '#e0e0e0', color: tipoFiltro === 'retirada' ? '#fff' : '#424242', bgcolor: tipoFiltro === 'retirada' ? '#6a1b9a' : '#fff' }}
          >
            Retirada
          </Button>
        </Box>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          {stats.map((stat) => (
            <Grid item xs={12} sm={4} md={2.4} key={stat.id}>
              <Paper elevation={0} sx={{ p: 2, borderRadius: '12px', border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar variant="rounded" sx={{ bgcolor: stat.bgColor, color: stat.color, borderRadius: '8px', width: 42, height: 42 }}>
                  {stat.icon}
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1 }}>{stat.count}</Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>{stat.label}</Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
          <TextField
            fullWidth
            placeholder="Buscar por cliente ou número do pedido..."
            value={searchQuery}
            onChange={this.handleSearchChange}
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (<InputAdornment position="start"><SearchIcon color="action" /></InputAdornment>),
              sx: { borderRadius: '10px', backgroundColor: '#fff' }
            }}
          />
        </Box>

        <Grid container spacing={2}>
          {/* Coluna 1: RECEBIDOS */}
          <Grid item xs={12} md={2.4}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', bgcolor: '#fff', minHeight: 420, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <InboxOutlinedIcon sx={{ color: '#7b1fa2' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Recebidos</Typography>
                </Box>
                <Chip label={received.length} size="small" sx={{ bgcolor: '#f3e5f5', color: '#7b1fa2', fontWeight: 'bold' }} />
              </Box>

              {received.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 6, color: '#9e9e9e' }}>
                  <InboxOutlinedIcon sx={{ fontSize: 32, mb: 1 }} />
                  <Typography variant="caption">Nenhum pedido</Typography>
                </Box>
              ) : (
                received.map(p => (
                  <Card key={p.id} variant="outlined" sx={{ mb: 2, borderRadius: '10px', borderColor: '#e0e0e0' }}>
                    <CardContent sx={{ pb: 1, p: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#7b1fa2' }}>{p.codigo}</Typography>
                        <Chip label={p.tipo} size="small" color="secondary" variant="outlined" sx={{ height: 20, fontSize: '0.65rem' }} />
                      </Box>
                      <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>{p.cliente}</Typography>

                      {/* Exibição Estruturada de Itens e Opções */}
                      {this.renderItensPedido(p.itens)}

                      <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, mt: 1 }}>
                        Total: {typeof p.total === 'number' ? `R$ ${p.total.toFixed(2).replace('.', ',')}` : p.total}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ pt: 0, px: 1.5, pb: 1.5, justifyContent: 'space-between' }}>
                      <Button size="small" startIcon={<PrintIcon fontSize="small" />} onClick={() => this.handleImprimirCozinha(p)} sx={{ textTransform: 'none', fontSize: '0.75rem' }}>
                        Imprimir 1
                      </Button>

                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          size="small"
                          variant="contained"
                          color="error"
                          startIcon={<CancelIcon fontSize="small" />}
                          onClick={() => this.handleOpenCancelar(p)}
                          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                        >
                          Cancelar
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          endIcon={<NavigateNextIcon fontSize="small" />}
                          onClick={() => this.handleOpenProduzir(p)}
                          sx={{ textTransform: 'none', bgcolor: '#7b1fa2', fontSize: '0.75rem' }}
                        >
                          Produzir
                        </Button>
                      </Box>
                    </CardActions>
                  </Card>
                ))
              )}
            </Paper>
          </Grid>

          {/* Coluna 2: EM PRODUÇÃO */}
          <Grid item xs={12} md={2.4}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', bgcolor: '#fff', minHeight: 420, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AccessTimeOutlinedIcon sx={{ color: '#ed6c02' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Em Produção</Typography>
                </Box>
                <Chip label={emProducao.length} size="small" sx={{ bgcolor: '#fff8e1', color: '#ed6c02', fontWeight: 'bold' }} />
              </Box>

              {emProducao.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 6, color: '#9e9e9e' }}>
                  <AccessTimeOutlinedIcon sx={{ fontSize: 32, mb: 1 }} />
                  <Typography variant="caption">Nenhum em produção</Typography>
                </Box>
              ) : (
                emProducao.map(p => (
                  <Card key={p.id} variant="outlined" sx={{ mb: 2, borderRadius: '10px', borderColor: '#e0e0e0' }}>
                    <CardContent sx={{ pb: 1, p: 1.5 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#ed6c02', mb: 1 }}>
                        {p.codigo} - {p.cliente}
                      </Typography>

                      {this.renderItensPedido(p.itens)}

                    </CardContent>
                    <CardActions sx={{ pt: 0, px: 1.5, pb: 1.5, justifyContent: 'space-between' }}>
                      <Button size="small" startIcon={<PrintIcon fontSize="small" />} onClick={() => this.handleImprimirCozinha(p)} sx={{ textTransform: 'none', fontSize: '0.75rem' }}>
                        Reimprimir
                      </Button>
                      <Button size="small" variant="contained" endIcon={<NavigateNextIcon fontSize="small" />} onClick={() => {
                        this.setState({ dialogPronto: p });
                      }} sx={{ textTransform: 'none', bgcolor: '#ed6c02', fontSize: '0.75rem' }}>
                        Pronto
                      </Button>
                    </CardActions>
                  </Card>
                ))
              )}
            </Paper>
          </Grid>

          {/* Coluna 3: PRONTO */}
          <Grid item xs={12} md={2.4}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', bgcolor: '#fff', minHeight: 420, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckCircleOutlineOutlinedIcon sx={{ color: '#2e7d32' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Pronto</Typography>
                </Box>
                <Chip label={pronto.length} size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' }} />
              </Box>

              {pronto.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 6, color: '#9e9e9e' }}>
                  <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 32, mb: 1 }} />
                  <Typography variant="caption">Nenhum pronto</Typography>
                </Box>
              ) : (
                pronto.map(p => (
                  <Card key={p.id} variant="outlined" sx={{ mb: 2, borderRadius: '10px', borderColor: '#e0e0e0' }}>
                    <CardContent sx={{ pb: 1, p: 1.5 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2e7d32' }}>{p.codigo} - {p.cliente}</Typography>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>{p.endereco}</Typography>
                      {this.renderItensPedido(p.itens)}
                    </CardContent>
                    <CardActions sx={{ pt: 0, px: 1.5, pb: 1.5, justifyContent: 'space-between' }}>
                      <Button size="small" startIcon={<PrintIcon fontSize="small" />} onClick={() => this.handleImprimirEntrega(p)} sx={{ textTransform: 'none', fontSize: '0.75rem' }}>
                        Etiqueta
                      </Button>
                      <Button size="small" variant="contained" endIcon={<LocalShippingOutlinedIcon fontSize="small" />} onClick={() => {
                        this.setState({ dialogDespachar: p });
                      }} sx={{ textTransform: 'none', bgcolor: '#2e7d32', fontSize: '0.75rem' }}>
                        Despachar
                      </Button>
                    </CardActions>
                  </Card>
                ))
              )}
            </Paper>
          </Grid>

          {/* Coluna 4: EM ROTA */}
          <Grid item xs={12} md={2.4}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', bgcolor: '#fff', minHeight: 420, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocalShippingOutlinedIcon sx={{ color: '#0288d1' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Em Rota</Typography>
                </Box>
                <Chip label={emRota.length} size="small" sx={{ bgcolor: '#e3f2fd', color: '#0288d1', fontWeight: 'bold' }} />
              </Box>

              {emRota.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 6, color: '#9e9e9e' }}>
                  <LocalShippingOutlinedIcon sx={{ fontSize: 32, mb: 1 }} />
                  <Typography variant="caption">Nenhum em rota</Typography>
                </Box>
              ) : (
                emRota.map(p => (
                  <Card key={p.id} variant="outlined" sx={{ mb: 2, borderRadius: '10px', borderColor: '#e0e0e0' }}>
                    <CardContent sx={{ pb: 1, p: 1.5 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0288d1' }}>{p.codigo} - {p.cliente}</Typography>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>{p.endereco}</Typography>
                    </CardContent>
                    <CardActions sx={{ pt: 0, px: 1.5, pb: 1.5, justifyContent: 'flex-end' }}>
                      <Button size="small" variant="contained" endIcon={<CheckCircleOutlineOutlinedIcon fontSize="small" />} onClick={() => {
                        this.setState({ dialogEntregue: p });
                      }} sx={{ textTransform: 'none', bgcolor: '#0288d1', fontSize: '0.75rem' }}>
                        Entregue
                      </Button>
                    </CardActions>
                  </Card>
                ))
              )}
            </Paper>
          </Grid>

          {/* Coluna 5: ENTREGUES */}
          <Grid item xs={12} md={2.4}>
            <Paper elevation={0} sx={{ borderRadius: '12px', border: '1px solid #f0f0f0', bgcolor: '#fff', minHeight: 420, p: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckCircleOutlineOutlinedIcon sx={{ color: '#2e7d32' }} />
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Entregues</Typography>
                </Box>
                <Chip label={entregues.length} size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' }} />
              </Box>

              {entregues.length === 0 ? (
                <Box sx={{ textAlign: 'center', py: 6, color: '#9e9e9e' }}>
                  <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 32, mb: 1 }} />
                  <Typography variant="caption">Nenhum entregue</Typography>
                </Box>
              ) : (
                entregues.map(p => (
                  <Card key={p.id} variant="outlined" sx={{ mb: 2, borderRadius: '10px', borderColor: '#e0e0e0', opacity: 0.8 }}>
                    <CardContent sx={{ pb: 1, p: 1.5 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#2e7d32' }}>{p.codigo} - {p.cliente}</Typography>
                      <Typography variant="caption" color="text.secondary" display="block">Finalizado com sucesso</Typography>
                    </CardContent>
                  </Card>
                ))
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* DIALOG: PRODUZIR PEDIDO */}
        <Dialog open={dialogProduzirOpen} onClose={this.handleCloseDialogs} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 700 }}>Confirmar Produção</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Deseja iniciar a produção do pedido <strong>{pedidoSelecionado?.codigo}</strong> ({pedidoSelecionado?.cliente})? O comprovante para a cozinha será impresso automaticamente.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={this.handleCloseDialogs} disabled={loadingAction} sx={{ textTransform: 'none' }}>
              Voltar
            </Button>
            <Button
              onClick={this.handleConfirmarProduzir}
              variant="contained"
              disabled={loadingAction}
              sx={{ bgcolor: '#7b1fa2', '&:hover': { bgcolor: '#4a148c' }, textTransform: 'none' }}
            >
              {loadingAction ? <CircularProgress size={20} color="inherit" /> : 'Confirmar e Imprimir'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG: MARCAR COMO PRONTO */}
        <Dialog open={Object.keys(this.state.dialogPronto).length > 0} onClose={this.handleCloseDialogs} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 700 }}>Marcar como Pronto?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Deseja marcar o pedido <strong>{this.state.dialogPronto?.codigo}</strong> como pronto? A etiqueta de entrega será impressa.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={this.handleCloseDialogs} disabled={loadingAction} sx={{ textTransform: 'none' }}>
              Voltar
            </Button>
            <Button
              onClick={async () => {
                const pedido = this.state.dialogPronto;
                this.setState({ loadingAction: true });
                try {
                  const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery/status`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ pedido_id: pedido.id, status: 'pronto' })
                  });
                  if (res.ok) {
                    this.handleMudarStatusLocal(pedido.id, 'pronto');
                    // Impressão da Etiqueta de Entrega na confirmação da API
                    this.handleImprimirEntrega(pedido);
                    this.setState({ dialogPronto: {} });
                    toast.success('Pedido marcado como pronto e etiqueta impressa!');
                  }
                } catch (err) {
                  toast.error('Erro ao atualizar status.');
                } finally {
                  this.setState({ loadingAction: false });
                }
              }}
              variant="contained"
              disabled={loadingAction}
              sx={{ bgcolor: '#7b1fa2', '&:hover': { bgcolor: '#4a148c' }, textTransform: 'none' }}
            >
              {loadingAction ? <CircularProgress size={20} color="inherit" /> : 'Confirmar e Imprimir Etiqueta'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG: DESPACHAR PEDIDO */}
        <Dialog open={Object.keys(this.state.dialogDespachar).length > 0} onClose={this.handleCloseDialogs} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 700 }}>Despachar Pedido?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Despachar o Pedido <strong>{this.state.dialogDespachar?.codigo}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={this.handleCloseDialogs} disabled={loadingAction} sx={{ textTransform: 'none' }}>
              Voltar
            </Button>
            <Button
              onClick={async () => {
                const pedido = this.state.dialogDespachar;
                this.setState({ loadingAction: true });
                try {
                  const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery/status`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ pedido_id: pedido.id, status: 'em_rota' })
                  });
                  if (res.ok) {
                    this.handleMudarStatusLocal(pedido.id, 'em_rota');
                    this.setState({ dialogDespachar: {} });
                    toast.success('Pedido despachado!');
                  }
                } catch (err) {
                  toast.error('Erro ao despachar.');
                } finally {
                  this.setState({ loadingAction: false });
                }
              }}
              variant="contained"
              disabled={loadingAction}
              sx={{ bgcolor: '#7b1fa2', '&:hover': { bgcolor: '#4a148c' }, textTransform: 'none' }}
            >
              {loadingAction ? <CircularProgress size={20} color="inherit" /> : 'Confirmar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG: MARCAR COMO ENTREGUE */}
        <Dialog open={Object.keys(this.state.dialogEntregue).length > 0} onClose={this.handleCloseDialogs} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 700 }}>Marcar como Entregue?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Deseja marcar o pedido <strong>{this.state.dialogEntregue?.codigo}</strong> como entregue?
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={this.handleCloseDialogs} disabled={loadingAction} sx={{ textTransform: 'none' }}>
              Voltar
            </Button>
            <Button
              onClick={async () => {
                const pedido = this.state.dialogEntregue;
                this.setState({ loadingAction: true });
                try {
                  const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3000'}/delivery/status`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ pedido_id: pedido.id, status: 'entregues' })
                  });
                  if (res.ok) {
                    this.handleMudarStatusLocal(pedido.id, 'entregues');
                    this.setState({ dialogEntregue: {} });
                    toast.success('Pedido entregue!');
                  }
                } catch (err) {
                  toast.error('Erro ao finalizar pedido.');
                } finally {
                  this.setState({ loadingAction: false });
                }
              }}
              variant="contained"
              disabled={loadingAction}
              sx={{ bgcolor: '#7b1fa2', '&:hover': { bgcolor: '#4a148c' }, textTransform: 'none' }}
            >
              {loadingAction ? <CircularProgress size={20} color="inherit" /> : 'Confirmar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG: CANCELAR PEDIDO */}
        <Dialog open={dialogCancelarOpen} onClose={this.handleCloseDialogs} fullWidth maxWidth="xs">
          <DialogTitle sx={{ fontWeight: 700, color: '#d32f2f' }}>Cancelar Pedido</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Tem certeza que deseja cancelar o pedido <strong>{pedidoSelecionado?.codigo}</strong>?
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Motivo do Cancelamento (opcional)"
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              value={motivoCancelamento}
              onChange={(e) => this.setState({ motivoCancelamento: e.target.value })}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={this.handleCloseDialogs} disabled={loadingAction} sx={{ textTransform: 'none' }}>
              Voltar
            </Button>
            <Button
              onClick={this.handleConfirmarCancelar}
              variant="contained"
              color="error"
              disabled={loadingAction}
              sx={{ textTransform: 'none' }}
            >
              {loadingAction ? <CircularProgress size={20} color="inherit" /> : 'Confirmar Cancelamento'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Delivery;